<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="body">
  <div class="test">
    <div class="column column-one">
      <div class="content-wrapper">
        <div class="dialog-title">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          Talk with us
        </div>
        <div>
          <p>
            Connect with us to see what we can do for you as you try out HUNTER
            Community.
          </p>
          <div class="point">
            <i class="k-icon k-font-icon k-i-file-ascx"></i>
            <div class="content">
              <strong>Trial Hunt Management Module Access </strong>
              <div>
                Utilize features to customize queries, generate detailed
                post-hunt reports, document hunt notes efficiently, and track
                essential metrics/KPIs.
              </div>
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-html"></i>
            <div class="content">
              <strong>Customized Guided Hunt Plan</strong>
              <div>
                Receive a curated list of Hunt Packages targeting prominent
                Malware/Ransomware Families, TTPs, and relevant threat actors to
                your organization.
              </div>
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-chart-line-stacked"></i>
            <div class="content">
              <strong>Tailored Hunt Collection </strong>
              <div>
                Unlock exclusive access to premium hunt content and specialized
                hunt package collections tailored to your needs.
              </div>
            </div>
          </div>

          <cyborg-button (click)="talkToCyborg()" color="primary">
            Talk to an Intel 471 Expert</cyborg-button
          >
        </div>
      </div>
    </div>
  </div>
</div>
